import React from 'react';
import $ from 'jquery';

class CartButton extends React.Component{

	constructor(props) {
	    super(props);
	}

	componentDidMount(){

		var elements = document.getElementsByClassName("cartButton");

		for (var i=0; i<elements.length; i++) {
		    elements[i].addEventListener("click", (e) => {
		    	if(e.target.disabled === false){

		    			$('#popupWindow').fadeIn(2000,() => {$('#popupWindow').fadeOut(1000)})

		    	}

		    	e.target.disabled = true;
		    	e.target.classList.add('disabled');

		    	window.setTimeout(() => {
					e.target.disabled = false;
					e.target.classList.remove('disabled');
		    	},1500)
		    });
		};
	};

	render(){
	
		return (
				<button onClick = {this.props.clickHandler} type="button" className ="cartButton btn btn-primary">Add to cart</button>
			)
	
	}


}



export default CartButton;